const editProfileInfoDictPT = {
  choose: "Escolher",
  cancel: "Cancelar",
  dragImgFile: "Arraste o arquivo de imagem aqui",
  zipCode: "Código Postal",
  country: "País",
  state: "Estado",
  city: "Cidade",
  publicPlace: "Logradouro",
  district: "Bairro",
  number: "Número",
  countryPhoneCode: "Cód. de Tel. do País",
  regionalPhoneCode: "Cód. de Tel. Regional",
  phoneNumber: "Número de Tel.",
  changeProfilePic: "Trocar Foto de Perfil",
  confirmProfileChanges: "Confirmar Mudanças no Perfil",
  // toast
  pleaseChoosePfp: "Por favor escolha uma foto de perfil primeiro.",
  fileSizeTooBig: "O tamanho do arquivo é muito grande.",
  unexpectedErrorUploadImg: "Erro inesperado ao carregar a imagem.",
  usernameCantBeEmpty:
    "O nome do usuário deve conter apenas letras minúsculas e números. Não pode estar vázio ou conter espaços.",
  usernameNotAvailable: "Nome de usuário não disponível.",
  unexpectedErrorChangingPfp: "Erro inesperado ao alterar o perfil.",
  sucessfullyEditedProfile: "Perfil editado com sucesso.",
  unexpectedSystemBehaviour: "Comportamento inesperado do sistema.",
  canRetriveOnSaturdays: "O serviço de frete pode buscar o pedido nos dias de sábado?",
  quantityOfDaysToRetrive:
    "Quantidade de dias para o serviço de frete ir buscar seu pedido para levar ao destino",
  // Settings page
  settingsPageTitle: "Configurações",
  settingsPageProfileInfoTitle: "Informações de Perfil",
  settingsPageSubtitle: "Gerencie suas preferências e opções.",
  upgradeAccount: "Upgrade da conta",
  logout: "Sair",
  settingsTabGeneral: "Configurações gerais",
  settingsTabProfile: "Configurações de perfil",
  profileSettingsSubtitle: "Atualize seu perfil e preferências de frete.",
  settingsTabPrivacy: "Privacidade e segurança",
  settingsMenuSelection: "Menu de seleção",
  regionalPreferences: "Preferências regionais",
  regionalPreferencesSubtitle: "Selecione as preferências para sua região.",
  language: "Língua",
  timezone: "Fuso orário",
  timeFormatOptional: "Formato de hora (Opcional)",
  dateFormatOptional: "Formato de data (Opcional)",
  hours: "horas",
  contactInfo: "Informações de contato",
  contactInfoSubtitle: "Informe seu telefone e endereço.",
  applyChanges: "Aplicar modificações",
  confirm: "Confirmar",
  changePassword: "Alterar a senha",
  changePasswordSubtitle: "Atualize a senha para maior segurança da conta.",
  currentPassword: "Senha atual",
  newPassword: "Nova senha",
  confirmPassword: "Confirmar nova senha",
  passwordMustContainAtLeast: "Deve conter ao menos:",
  passwordRequirementUppercase: "1 letra maiúscula",
  passwordRequirementNumber: "1 número",
  passwordRequirementLength: "8 caracteres",
  passwordStrengthNone: "",
  passwordStrengthWeak: "Fraca",
  passwordStrengthMedium: "Média",
  passwordStrengthStrong: "Forte",
  loading: "Carregando...",
  deleteAccount: "Eliminar conta",
  deleteAccountSubtitle: "Gerencie o processo de cancelamento da conta.",
  deleteAccountWarning: "Esta ação não pode ser desfeita.",
  deleteAccountInfo: "Todos os seus dados, incluindo perfil e informações pessoais, serão removidos permanentemente.",
  writeCancelToConfirm: "Digite CANCELAR para confirmar",
  confirmYourPassword: "Confirme sua senha",
  passwordChangedSuccessfully: "Senha alterada com sucesso.",
  accountCanceledSuccessfully: "Conta cancelada com sucesso.",
  passwordFieldsMismatched: "As senhas não coincidem.",
  cancelAccountError: "Erro ao cancelar conta.",
  firstName: "Nome",
  surname: "Sobrenome",
  username: "Nome de usuário",
  uploadImage: "Carregar imagem",
  freight: "Frete",
  select: "Selecionar",
  profileAnalysisTab: "Análise de perfil",
  profileAnalysisMenuItem: "Análise de perfil",
  profileAnalysisTitle: "Análise do Perfil e dos Objetivos",
  profileAnalysisSubtitle:
    "Responda a estas breves perguntas para nos ajudar a entender seus objetivos.",
  profileAnalysisAddress: "Endereço",
  profileAnalysisAddressHelp: "Insira seu endereço de residência atual.",
  profileAnalysisNationality: "Nacionalidade",
  profileAnalysisBirthPlace: "Local de Nascimento",
  profileAnalysisBirthDate: "Data de Nascimento",
  profileAnalysisBirthDatePlaceholder: "DD/MM/AAAA",
  profileAnalysisPhone: "Telefone",
  profileAnalysisEmail: "E-mail",
  profileAnalysisEmployment: "Atividade Profissional",
  profileAnalysisMaritalStatus: "Estado Civil",
  profileAnalysisEducationLevel: "Nível de Escolaridade",
  profileAnalysisHouseholdMembers: "Membros do Núcleo Familiar",
  profileAnalysisObjectives: "Objetivos",
  profileAnalysisNeeds: "Necessidades",
  profileAnalysisDateLabel: "Data: ",
  profileAnalysisConsultantLabel: "Consultor: ",
  profileAnalysisNoData: "—",
  profileAnalysisConsentLabel: "Eu consinto",
  profileAnalysisConsentText:
    "As informações serão usadas para elaborar uma avaliação gratuita para a plataforma EXTRACONOMY.",
  profileAnalysisSendDiagnosis: "Enviar Diagnóstico",
  profileAnalysisUpdateDiagnosis: "Atualizar Diagnóstico",
  profileAnalysisSubmitSuccess: "Diagnóstico enviado com sucesso.",
  profileAnalysisMaritalSingle: "Solteiro(a)",
  profileAnalysisMaritalMarried: "Casado(a)",
  profileAnalysisMaritalDivorced: "Divorciado(a)",
  profileAnalysisMaritalWidowed: "Viúvo(a)",
  profileAnalysisMaritalCivilUnion: "União civil",
  profileAnalysisMaritalSeparated: "Separado(a)",
};

export default editProfileInfoDictPT;
